import { ExpandMore } from '@mui/icons-material'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { createTheme } from '@mui/material/styles'
import {
  Link as RouterLink
} from 'react-router-dom'

const shadows = [
  'none',
  '0px 2px 1px -1px rgba(0, 0, 0, 0.06),0px 1px 1px 0px rgba(0, 0, 0, 0.042),0px 1px 3px 0px rgba(0, 0, 0, 0.036)',
  '0px 3px 1px -2px rgba(0, 0, 0, 0.06),0px 2px 2px 0px rgba(0, 0, 0, 0.042),0px 1px 5px 0px rgba(0, 0, 0, 0.036)',
  '0px 3px 3px -2px rgba(0, 0, 0, 0.06),0px 3px 4px 0px rgba(0, 0, 0, 0.042),0px 1px 8px 0px rgba(0, 0, 0, 0.036)',
  '0px 2px 4px -1px rgba(0, 0, 0, 0.06),0px 4px 5px 0px rgba(0, 0, 0, 0.042),0px 1px 10px 0px rgba(0, 0, 0, 0.036)',
  '0px 3px 5px -1px rgba(0, 0, 0, 0.06),0px 5px 8px 0px rgba(0, 0, 0, 0.042),0px 1px 14px 0px rgba(0, 0, 0, 0.036)',
  '0px 3px 5px -1px rgba(0, 0, 0, 0.06),0px 6px 10px 0px rgba(0, 0, 0, 0.042),0px 1px 18px 0px rgba(0, 0, 0, 0.036)',
  '0px 4px 5px -2px rgba(0, 0, 0, 0.06),0px 7px 10px 1px rgba(0, 0, 0, 0.042),0px 2px 16px 1px rgba(0, 0, 0, 0.036)',
  '0px 5px 5px -3px rgba(0, 0, 0, 0.06),0px 8px 10px 1px rgba(0, 0, 0, 0.042),0px 3px 14px 2px rgba(0, 0, 0, 0.036)',
  '0px 5px 6px -3px rgba(0, 0, 0, 0.06),0px 9px 12px 1px rgba(0, 0, 0, 0.042),0px 3px 16px 2px rgba(0, 0, 0, 0.036)',
  '0px 6px 6px -3px rgba(0, 0, 0, 0.06),0px 10px 14px 1px rgba(0, 0, 0, 0.042),0px 4px 18px 3px rgba(0, 0, 0, 0.036)',
  '0px 6px 7px -4px rgba(0, 0, 0, 0.06),0px 11px 15px 1px rgba(0, 0, 0, 0.042),0px 4px 20px 3px rgba(0, 0, 0, 0.036)',
  '0px 7px 8px -4px rgba(0, 0, 0, 0.06),0px 12px 17px 2px rgba(0, 0, 0, 0.042),0px 5px 22px 4px rgba(0, 0, 0, 0.036)',
  '0px 7px 8px -4px rgba(0, 0, 0, 0.06),0px 13px 19px 2px rgba(0, 0, 0, 0.042),0px 5px 24px 4px rgba(0, 0, 0, 0.036)',
  '0px 7px 9px -4px rgba(0, 0, 0, 0.06),0px 14px 21px 2px rgba(0, 0, 0, 0.042),0px 5px 26px 4px rgba(0, 0, 0, 0.036)',
  '0px 8px 9px -5px rgba(0, 0, 0, 0.06),0px 15px 22px 2px rgba(0, 0, 0, 0.042),0px 6px 28px 5px rgba(0, 0, 0, 0.036)',
  '0px 8px 10px -5px rgba(0, 0, 0, 0.06),0px 16px 24px 2px rgba(0, 0, 0, 0.042),0px 6px 30px 5px rgba(0, 0, 0, 0.036)',
  '0px 8px 11px -5px rgba(0, 0, 0, 0.06),0px 17px 26px 2px rgba(0, 0, 0, 0.042),0px 6px 32px 5px rgba(0, 0, 0, 0.036)',
  '0px 9px 11px -5px rgba(0, 0, 0, 0.06),0px 18px 28px 2px rgba(0, 0, 0, 0.042),0px 7px 34px 6px rgba(0, 0, 0, 0.036)',
  '0px 9px 12px -6px rgba(0, 0, 0, 0.06),0px 19px 29px 2px rgba(0, 0, 0, 0.042),0px 7px 36px 6px rgba(0, 0, 0, 0.036)',
  '0px 10px 13px -6px rgba(0, 0, 0, 0.06),0px 20px 31px 3px rgba(0, 0, 0, 0.042),0px 8px 38px 7px rgba(0, 0, 0, 0.036)',
  '0px 10px 13px -6px rgba(0, 0, 0, 0.06),0px 20px 31px 3px rgba(0, 0, 0, 0.042),0px 8px 38px 7px rgba(0, 0, 0, 0.036)',
  '0px 10px 13px -6px rgba(0, 0, 0, 0.06),0px 20px 31px 3px rgba(0, 0, 0, 0.042),0px 8px 38px 7px rgba(0, 0, 0, 0.036)',
  '0px 10px 13px -6px rgba(0, 0, 0, 0.06),0px 20px 31px 3px rgba(0, 0, 0, 0.042),0px 8px 38px 7px rgba(0, 0, 0, 0.036)',
  '0px 10px 13px -6px rgba(0, 0, 0, 0.06),0px 20px 31px 3px rgba(0, 0, 0, 0.042),0px 8px 38px 7px rgba(0, 0, 0, 0.036)'
]

export const inputBackgroundDisabled = '#0000000D'
export const inputBorderDisabled = '#00000066'

export const baseMUITheme = mode => createTheme(
  {
    typography: {
      fontFamily: 'Open Sans',
      fontSize: 14,
      allVariants: {
        fontFamily: 'Open Sans'
      },
      button: {
        textTransform: 'none'
      },
      h1: {
        fontSize: 35,
        fontWeight: 600,
        lineHeight: '48px',
        marginBottom: 24
      },
      h2: {
        fontSize: 30,
        fontWeight: 600,
        lineHeight: '36px'
      },
      h3: {
        fontSize: 24,
        fontWeight: 600,
        lineHeight: '28px'
      },
      h4: {
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '25px'
      },
      h5: {
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '24px'
      },
      h6: {
        fontSize: 18,
        fontWeight: 400,
        lineHeight: '24px'
      },
      body1: {
        fontSize: 16,
        lineHeight: '25px',
        fontWeight: 400
      },
      body2: {
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 600
      },
      body3: {
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 400
      }
    },
    shadows,
    breakpoints: {
      values: {
        xs: 490,
        pu2: 670,
        sm: 1280,
        md: 1440,
        lg: 1600,
        xl: 1920
      }
    },
    components: {
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 0
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 0
          }
        }
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontFamily: 'Open Sans'
          }
        }
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            fontSize: '14px',
            fontWeight: '400',
            padding: '12px 4px'
          },
          root: {
            fontSize: '14px',
            whiteSpace: 'pre-wrap',
            padding: '8px 4px'
          }
        }
      },
      MuiCard: {
        defaultProps: {
          elevation: 0
        },
        styleOverrides: {
          root: ({ ownerState, theme, ...props }) => ({
            borderRadius: 0,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: theme.palette.primary.main
          })
        }
      },
      MuiIconButton: {
        styleOverrides: {
          root: ({ ownerState, theme, ...props }) => ({
            [theme.breakpoints.down('md')]: {
              fontSize: '20px'
            }
          })
        }
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            fontSize: 'inherit'
          }
        }
      },
      MuiTooltip: {
        defaultProps: {
          arrow: true
        },
        styleOverrides: {
          arrow: ({ ownerState, theme, ...props }) => ({
            color: theme.palette.primary.main
          }),
          tooltip: ({ ownerState, theme, ...props }) => ({
            fontSize: '14px',
            fontWeight: 600,
            paddingLeft: 18,
            paddingRight: 18,
            paddingTop: 6,
            paddingBottom: 6,
            backgroundColor: theme.palette.primary.main
          })
        }
      },
      MuiButtonBase: {
        styleOverrides: {
          root: {
            fontFamily: 'Open Sans'
          }
        }
      },
      MuiInputLabel: {
        styleOverrides: {
          root: ({ ownerState, theme, ...props }) => ({
            fontSize: '12px'
          })
        }
      },
      MuiSelect: {
        styleOverrides: {
          select: ({ ownerState, theme, ...props }) => {
            const isCompact = ownerState?.SelectDisplayProps?.['data-compact']
            return {
              fontWeight: 600,
              fontSize: 14,
              lineHeight: '19px',
              paddingLeft: isCompact ? 16 : null,
              paddingRight: isCompact ? 16 : null,
              paddingTop: isCompact ? 8 : null,
              paddingBottom: isCompact ? 8 : null,
              '&:hover': {
                backgroundColor: '#17374F1A',
                opacity: 0.8,
                boxShadow: shadows[8]
              },
              [theme.breakpoints.down('md')]: {
                fontSize: '12px',
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 7,
                paddingBottom: 7
              }
            }
          },
          icon: ({ ownerState, theme, ...props }) => ({
            color: theme.palette.primary.main
          })
        },
        defaultProps: {
          IconComponent: ExpandMore,
          displayEmpty: true
        }
      },
      MuiFilledInput: {
        defaultProps: {
          sx: {
            fontSize: '14px'
          }
        }
      },
      MuiOutlinedInput: {
        defaultProps: {
          sx: {
            fontSize: '14px'
          }
        },
        styleOverrides: {
          root: ({ ownerState, theme, ...props }) => ({
            borderRadius: 0,
            lineHeight: '19px',
            '& fieldset': {
              borderWidth: 1.6,
              borderColor: theme.palette.primary.main
            },
            '&.Mui-disabled fieldset': {
              borderColor: `${inputBorderDisabled} !important`
            }
          }),
          error: ({ ownerState, theme, ...props }) => ({
            '& fieldset': {
              borderColor: `${theme.palette.primary.main} !important`
            }
          })
        }
      },
      MUIDataTableBodyCell: {
        styleOverrides: {
          root: {
            fontSize: '15px',
            lineHeight: '25px',
            fontWeight: 400,
            verticalAlign: 'top',
            '&:first-of-type': {
              padding: '16px 16px 16px 32px'
            },
            '&:last-of-type': {
              paddingRight: '32px'
            }
          },
          head: {
            fontSize: '15px',
            fontWeight: 400,
            lineHeight: '25px',
            textAlign: 'left',
            justifyContent: 'flex-start'
          }
        }
      },
      MuiButton: {
        defaultProps: {
          sx: {
            minWidth: 'unset'
          }
        },
        styleOverrides: {
          root: ({ ownerState, theme, ...props }) => {
            return {
              fontSize: '14px',
              fontFamily: 'Open Sans',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '0 !important',
              paddingLeft: 16,
              paddingRight: 16,
              paddingTop: 8,
              paddingBottom: 8,
              lineHeight: '19px',
              [theme.breakpoints.down('md')]: {
                fontSize: '12px',
                paddingLeft: 13,
                paddingRight: 13,
                paddingTop: 7,
                paddingBottom: 7
              },
              '&:hover': {
                opacity: 0.8,
                boxShadow: shadows[8]
              },
              '&:selected': {
                backgroundColor: theme.palette[ownerState.color].main
              },
              '&.Mui-disabled': {
                color: '#ffffff',
                backgroundColor: theme.palette[ownerState.color].main,
                opacity: 0.35
              }
            }
          },
          text: ({ ownerState, theme, ...props }) => {
            return {
              '&:hover': {
                backgroundColor: 'transparent',
                opacity: 0.8,
                boxShadow: 'initial'
              }
            }
          },
          outlined: ({ ownerState, theme, ...props }) => {
            const base = {
              paddingLeft: 15,
              paddingRight: 15,
              paddingTop: 7,
              paddingBottom: 7,
              [theme.breakpoints.down('md')]: {
                paddingLeft: 12,
                paddingRight: 12,
                paddingTop: 6,
                paddingBottom: 6
              }
            }
            const isSecondary = ownerState.color === 'secondary'

            if (isSecondary) {
              return {
                ...base,
                borderWidth: 1.6,
                color: theme.palette[ownerState.color].contrastText,
                border: undefined,
                borderColor: theme.palette[ownerState.color].contrastText,
                '&:hover': {
                  border: undefined,
                  backgroundColor: '#FFFFFF40',
                  borderColor: theme.palette[ownerState.color].contrastText,
                  borderWidth: 1.6
                },
                '&.Mui-disabled': {
                  color: theme.palette[ownerState.color].contrastText,
                  backgroundColor: theme.palette[ownerState.color].disabledWhite
                }
              }
            }

            return {
              ...base,
              borderWidth: 1.6,
              border: undefined,
              borderColor: theme.palette[ownerState.color].main,
              '&:hover': {
                borderWidth: 1.6,
                backgroundColor: '#17374F1A'
              },
              '&.Mui-disabled': {
                color: theme.palette[ownerState.color].main,
                backgroundColor: '#FF00FF05'
              }
            }
          },
          contained: ({ ownerState, theme, ...props }) => {
            return {
              boxShadow: shadows[0],
              color: ownerState.color === 'secondary' && theme.palette[ownerState.color].text,
              backgroundColor: ownerState.color === 'secondary' && 'rgba(154, 199, 101, 0.6) !important'
            }
          }
        }
      },
      MuiMenu: {
        styleOverrides: {
          list: ({ ownerState, theme, ...props }) => ({
            // borderCollapse: 'collapse',
            borderWidth: 1.6,
            borderStyle: 'solid',
            borderColor: theme.palette.primary.main,
            paddingTop: 0,
            paddingBottom: 0
          })
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            minHeight: 20,
            fontSize: 14,
            lineHeight: '19px',
            '&.Mui-selected': {
              fontWeight: 600,
              backgroundColor: 'rgba(23, 55, 79, 0.10)'
            }
          }
        }
      },
      MuiAutocomplete: {
        defaultProps: {
          popupIcon: <ExpandMore />
        },
        styleOverrides: {
          option: ({ theme }) => ({
            fontSize: 14,
            lineHeight: '19px',
            [theme.breakpoints.down('md')]: {
              lineHeight: '16px'
            },
            minHeight: '20px !important',
            '&[aria-selected="true"]': {
              fontWeight: 600
            }
          }),
          popupIndicator: ({ theme }) => ({
            '& .MuiSvgIcon-root': {
              color: theme.palette.primary.main,
              fontSize: 14
            }
          }),
          clearIndicator: ({ theme }) => ({
            '& .MuiSvgIcon-root': {
              color: theme.palette.primary.main,
              fontSize: 14
            }
          }),
          root: ({ theme }) => ({
            '& .MuiInputBase-input': {
              fontWeight: 600,
              fontSize: 14,
              lineHeight: '19px',
              [theme.breakpoints.down('md')]: {
                fontSize: 12
              }
            },
            '& .MuiInputBase-root': {
              fontWeight: 600,
              fontSize: 14,
              lineHeight: '19px',
              [theme.breakpoints.down('md')]: {
                fontSize: 12,
                paddingLeft: 5,
                paddingRight: 0,
                paddingTop: 0,
                paddingBottom: 0
              }
            }
          }),
          paper: ({ theme }) => ({
            border: '1px solid',
            borderColor: theme.palette.primary.main
          }),
          listbox: {
            padding: 0
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            backgroundColor: '#ffff',
            '&.Mui-disabled': {
              backgroundColor: inputBackgroundDisabled,
              color: '#225858',
              border: 'rgba(0, 0, 0, 0.05)'
            },
            '& .MuiInputBase-input': {
              minWidth: 80
            }
          }
        }
      },
      MuiFormControlLabel: {
        styleOverrides: {
          label: {
            fontSize: 14
          },
          root: {
            marginBottom: 4,
            marginLeft: 0

          }
        }
      },
      MuiDialogContent: {
        styleOverrides: {
          root: ({ ownerState, theme, ...props }) => ({
            paddingLeft: 48,
            paddingRight: 48,
            paddingBottom: 48
          })
        }
      },
      MuiDialogContentText: {
        styleOverrides: {
          root: ({ ownerState, theme, ...props }) => ({
            fontSize: 14,
            color: '#000000',
            paddingBottom: 8
          })
        }
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: ({ ownerState, theme, ...props }) => ({
            fontSize: 12,
            color: '#000000',
            lineHeight: '16px',
            fontWeight: 600,
            marginLeft: 0,
            marginTop: 8
            // '&.Mui-disabled': {
            //   color: '#585858'
            // }
          })
        }
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            backgroundColor: 'red'
          },
          selected: {
          }
        }
      },
      MuiLink: {
        defaultProps: {
          underline: 'hover',
          component: RouterLink
        },
        styleOverrides: {
          root: ({ ownerState, theme, ...props }) => ({
            fontWeight: 400,
            color: theme.palette.secondaryDark.main,
            '&:hover': {
              color: theme.palette.primary.main
            }
          })
        }
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            padding: 6,
            marginRight: 4,
            '& .MuiSvgIcon-root': {
              fontSize: 20
            }
          }
        }
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            fontSize: 24,
            padding: 6,
            marginRight: 4
          }

        }
      },
      MuiStepLabel: {
        styleOverrides: {
          label: {
            fontWeight: '400 !important',
            '&.Mui-active': {
              fontWeight: 'bold !important'
            }
          }
        }
      },
      MuiStepIcon: {
        styleOverrides: {
          root: {
            width: 24,
            height: 24
          },
          text: {
            fontSize: 14,
            fontWeight: 600
          }

        }
      },
      MuiAlert: {
        defaultProps: {
          severity: 'info',
          iconMapping: {
            error: <CancelOutlinedIcon />,
            success: <CheckCircleOutlineIcon />
          }
        },
        styleOverrides: {
          root: ({ ownerState, theme, ...props }) => {
            let color = theme.palette.primary.main
            if (ownerState.severity === 'error') {
              color = theme.palette.error.main
            } else if (ownerState.severity === 'success') {
              color = theme.palette.success.main
            } else if (ownerState.severity === 'warning') {
              color = theme.palette.warning.main
            }
            return {
              '&::before': {
                content: '" "',
                width: 10,
                height: 'auto',
                top: 0,
                bottom: 0,
                backgroundColor: color,
                display: 'block',
                position: 'absolute',
                left: 0
              },
              borderRadius: 0,
              paddingLeft: 37,
              paddingTop: 17,
              paddingRight: 27,
              paddingBottom: 17,
              lineHeight: '20px',
              fontSize: '14px',
              position: 'relative',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'flex-start',
              fontWeight: 400,
              backgroundColor: theme.palette.flareSecondary.main
            }
          },
          icon: ({ ownerState, theme, ...props }) => {
            let color = theme.palette.primary.main
            if (ownerState.severity === 'error') {
              color = theme.palette.error.main
            } else if (ownerState.severity === 'success') {
              color = theme.palette.success.main
            } else if (ownerState.severity === 'warning') {
              color = theme.palette.warning.main
            }
            return {
              fontSize: 30,
              marginRight: 8,
              fill: color,
              color
            }
          },
          message: ({ ownerState, theme, ...props }) => ({
            color: theme.palette.primary.main
          }),
          // Variant-specific styles
          filledInfo: ({ ownerState, theme, ...props }) => ({
            // backgroundColor: '#CAE5EF',
            '& .MuiAlert-icon': {
              color: theme.palette.primary.main
            }
          }),
          filledWarning: ({ ownerState, theme, ...props }) => ({
            // backgroundColor: '#EFDDCA',
            '& .MuiAlert-icon': {
              color: theme.palette.primary.main
            }
          }),
          filledError: ({ ownerState, theme, ...props }) => ({
            // backgroundColor: '#F0C6C6',
            '& .MuiAlert-icon': {
              color: theme.palette.primary.main
            }
          }),
          filledSuccess: ({ ownerState, theme, ...props }) => ({
            // backgroundColor: '#D0EFCA',
            '& .MuiAlert-icon': {
              color: theme.palette.primary.main
            }
          }),
          standardInfo: ({ ownerState, theme, ...props }) => ({
            '&::before': {
              backgroundColor: theme.palette.primary.main
            },
            backgroundColor: '#CAE5EF',
            '& .MuiAlert-icon': {
              color: theme.palette.primary.main
            }
          }),
          standardWarning: ({ ownerState, theme, ...props }) => ({
            '&::before': {
              backgroundColor: '#F47B44'
            },
            backgroundColor: '#CAE5EF',
            // backgroundColor: '#EFDDCA',
            '& .MuiAlert-icon': {
              color: '#F47B44'
            }
          }),
          standardError: ({ ownerState, theme, ...props }) => ({
            '&::before': {
              backgroundColor: '#E51C40'
            },
            backgroundColor: '#CAE5EF',
            '& .MuiAlert-icon': {
              color: '#E51C40'
            }
          }),
          standardSuccess: ({ ownerState, theme, ...props }) => ({
            '&::before': {
              backgroundColor: '#0A8646'
            },
            backgroundColor: '#CAE5EF',
            // backgroundColor: '#D0EFCA',
            '& .MuiAlert-icon': {
              color: '#0A8646'
            }
          }),
          outlinedInfo: ({ ownerState, theme, ...props }) => ({
            '&::before': {
              backgroundColor: theme.palette.primary.main
            },
            borderColor: theme.palette.primary.main,
            '& .MuiAlert-icon': {
              color: theme.palette.primary.main
            }
          }),
          outlinedWarning: ({ ownerState, theme, ...props }) => ({
            '&::before': {
              backgroundColor: '#F47B44'
            },
            borderColor: '#F47B44',
            '& .MuiAlert-icon': {
              color: '#F47B44'
            }
          }),
          outlinedError: ({ ownerState, theme, ...props }) => ({
            '&::before': {
              backgroundColor: '#E51C40'
            },
            borderColor: '#E51C40',
            '& .MuiAlert-icon': {
              color: '#E51C40'
            }
          }),
          outlinedSuccess: ({ ownerState, theme, ...props }) => ({
            '&::before': {
              backgroundColor: '#0A8646'
            },
            borderColor: '#0A8646',
            '& .MuiAlert-icon': {
              color: theme.palette.primary.main
            }
          })
        },
        variants: [
          {
            props: { size: 'small' },
            style: {
              padding: '5px 10px',
              paddingLeft: '5px',
              display: 'flex',
              alignItems: 'center',
              '& .MuiAlert-icon': {
                fontSize: 20,
                margin: 0,
                padding: 0,
                paddingLeft: '10px',
                paddingRight: '10px',
                display: 'flex',
                alignItems: 'center'
              },
              '& .MuiAlert-message': {
                padding: 0,
                display: 'flex',
                alignItems: 'center'
              },
              '&::before': {
                width: 5
              }
            }
          }
        ]
      },
      MuiAccordion: {
        styleOverrides: {
          root: ({ theme }) => ({
            backgroundColor: 'white',
            boxShadow: 'none',
            border: `1px solid ${theme.palette.primary.main}`,
            '&:first-of-type': {
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0
            },
            marginTop: 0,
            '&:last-of-type': {
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0
            }
          })
        }
      },
      MuiAlertTitle: {
        styleOverrides: {
          root: ({ ownerState, theme, ...props }) => ({
            fontSize: '16px !important',
            fontWeight: '700 !important',
            lineHeight: '18px !important',
            '.MuiAlert-standardInfo &': {
              color: theme.palette.primary.main
            },
            '.MuiAlert-standardWarning &': {
              color: theme.palette.primary.main
            },
            '.MuiAlert-standardError &': {
              color: theme.palette.primary.main
            },
            '.MuiAlert-standardSuccess &': {
              color: theme.palette.primary.main
            }
          })
        }
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor: '#f5f5f5',
            fontWeight: 400
          }
        },
        MuiAccordionSummary: {
          styleOverrides: {
            root: {
              marginTop: 0,
              padding: '10px 12px',
              minHeight: 'auto',
              '&.Mui-expanded': {
                minHeight: 'auto'
              }
            },
            content: {
              margin: 0,
              '&.Mui-expanded': {
                margin: 0
              }
            }

          }
        },
        MuiAccordionDetails: {
          styleOverrides: {
            root: {
              paddingRight: 0,
              paddingLeft: 0,
              marginLeft: 0,
              marginRight: 0
            }
          }
        },
        MuiPagination: {
          styleOverrides: {
            ul: {
              gap: '24px'
            }
          }
        },
        MuiPaginationItem: {
          styleOverrides: {
            root: {
              color: 'rgba(0, 0, 0, 0.54)',
              fontWeight: 400
            },
            page: ({ theme }) => ({
              '&.Mui-selected': {
                backgroundColor: 'rgba(23, 55, 79, 0.1)',
                fontWeight: 600,
                color: theme.palette.primary.main
              }
            }),
            previousNext: ({ theme }) => ({
              color: theme.palette.primary.main,
              '&.Mui-disabled': {
                color: 'rgba(23, 55, 79, 0.25)'
              }
            })
          }
        },
        MuiAutocomplete: {
          defaultProps: {
            popupIcon: <ExpandMore />
          },
          styleOverrides: {
            option: ({ theme }) => ({
              fontSize: 14,
              lineHeight: '19px',
              [theme.breakpoints.down('md')]: {
                lineHeight: '16px'
              },
              minHeight: '20px !important',
              '&[aria-selected="true"]': {
                fontWeight: 600
              }
            }),
            popupIndicator: ({ theme }) => ({
              '& .MuiSvgIcon-root': {
                color: theme.palette.primary.main,
                fontSize: 14
              }
            }),
            clearIndicator: ({ theme }) => ({
              '& .MuiSvgIcon-root': {
                color: theme.palette.primary.main,
                fontSize: 14
              }
            }),
            root: ({ theme }) => ({
              '& .MuiInputBase-input': {
                fontWeight: 600,
                fontSize: 14,
                lineHeight: '19px',
                [theme.breakpoints.down('md')]: {
                  fontSize: 12
                }
              },
              '& .MuiInputBase-root': {
                fontWeight: 600,
                fontSize: 14,
                lineHeight: '19px',
                [theme.breakpoints.down('md')]: {
                  fontSize: 12,
                  paddingLeft: 5,
                  paddingRight: 0,
                  paddingTop: 0,
                  paddingBottom: 0
                }
              }
            }),
            paper: ({ theme }) => ({
              border: '1px solid',
              borderColor: theme.palette.primary.main
            }),
            listbox: {
              padding: 0
            }
          }
        }
      }
    },
    header: {
      image: '/assets/images/centre-logo.svg'
    },
    sidebar: {
      main: '#E3ECEF',
      sidebarIconsColor: '#ffffff'
    },
    palette: {
      mode: 'light',
      background: {
        main: '#EEEEE657'
      },
      primary: {
        main: '#17374F',
        contrastText: '#ffffff'
      },
      primaryLight: {
        main: '#49BAD7',
        contrastText: '#ffffff'
      },
      secondary: {
        main: '#9AC765',
        light: '#bedd9a',
        text: '#17374F',
        contrastText: '#fffffa',
        disabledWhite: '#ADB8BF',
        green: '#0A8646'
      },
      secondaryDark: {
        main: '#0A8646',
        hover: '#FFFFFF40',
        contrastText: '#ffffff'
      },
      flarePrimary: {
        main: '#EEEFE6',
        contrastText: '#17374F'
      },
      flareSecondary: {
        main: '#CAE5EF'
      },
      warning: {
        main: '#F47B44'
      },
      success: {
        main: '#0A8646'
      },
      error: {
        main: '#E51C40'
      },
      text: {
        primary: '#000000',
        disabled: '#000000'
      },
      card: {
        main: '#ffffff',
        contrastText: '#17374F',
        hover: '#F5F4ED',
        assessmentCard: '#EEEFE6'
      },
      accordion: {
        main: '#fff',
        hover: 'rgba(23, 55, 79, 0.10)'
      },
      loading: {
        main: '#098746'
      }
    }
  }
)
